import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  TerminalRequestDetailsDto,
  TerminalRequestDto,
  TerminalRequestFilterInput,
  TerminalRequestRefInput,
  UpdateTerminalRequestStatusInput,
} from '@/api/types/terminalRequests';

// Routes derived from ABP conventional-controller mapping of
// Finkit.Host.TerminalManagement.TerminalRequestsManagementAppService:
//   GetListAsync(input)       -> GET  /api/app/terminal-requests-management
//   GetDetailsAsync(input)    -> GET  /api/app/terminal-requests-management/details
//   UpdateStatusAsync(input)  -> PUT  /api/app/terminal-requests-management/status
//   GetPendingCountAsync()    -> GET  /api/app/terminal-requests-management/pending-count
const BASE = '/api/app/terminal-requests-management';

export const terminalRequestsApi = {
  async getList(input: TerminalRequestFilterInput): Promise<PagedResult<TerminalRequestDto>> {
    const { data } = await http.get<PagedResult<TerminalRequestDto>>(BASE, { params: input });
    return data;
  },

  async getDetails(input: TerminalRequestRefInput): Promise<TerminalRequestDetailsDto> {
    const { data } = await http.get<TerminalRequestDetailsDto>(`${BASE}/details`, {
      params: input,
    });
    return data;
  },

  async updateStatus(input: UpdateTerminalRequestStatusInput): Promise<void> {
    await http.put(`${BASE}/status`, input);
  },

  // Count of pending (+ processing) requests across all tenants — drives the
  // sidebar badge on "LP Requests Management" (legacy menu counter).
  async getPendingCount(): Promise<number> {
    const { data } = await http.get<number>(`${BASE}/pending-count`);
    return Number(data) || 0;
  },
};
